import { Link } from "react-router-dom";
import { Ban } from "Components/ui/icons";

import { Button } from "Components/ui";
import { AuthLayout, StepHeader } from "./AuthLayout";

/** Where api/axiosConfig sends a user whose account was suspended mid-session or at sign-in. */
const AccountSuspended = () => (
  <AuthLayout>
    <div className="animate-in fade-in-0 slide-in-from-bottom-2 duration-300 motion-reduce:animate-none">
      <span className="mb-6 flex h-11 w-11 items-center justify-center rounded-card border border-danger/20 bg-danger-subtle text-danger">
        <Ban aria-hidden="true" className="h-5 w-5" />
      </span>
      <StepHeader
        title="Your account has been suspended"
        description="You've been signed out of Super Admin. Contact your administrator to restore access."
      />
      <Button asChild variant="secondary" size="lg" fullWidth>
        <Link to="/credentials">Back to sign in</Link>
      </Button>
    </div>
  </AuthLayout>
);

export default AccountSuspended;
